import React from 'react';
import { Card, CardMedia, CardContent, CardActions, Typography, IconButton } from '@material-ui/core';
import { AddShoppingCart } from '@material-ui/icons';

import useStyles from './styles';

const Product = ({ product, onAddToCart }) => {

    const classes = useStyles();

    const handleAddToCart = () => onAddToCart(product.id, 1);

    return (
        <Card className={classes.root}>
        <CardMedia className={classes.media} image={product.media.source} title={product.name} />
        <CardContent>
            <div className={classes.cardContent}>
            <Typography variant="h6" component="h2">
                {product.name}
            </Typography>
            </div>
            <Typography dangerouslySetInnerHTML={{ __html: product.description }} variant="body2" color="textSecondary" component="p" />
        </CardContent>
        <CardActions disableSpacing className={classes.cardActions}>
            <Typography gutterBottom variant="subtitle1" component="h2">
                {product.price.formatted_with_code}
            </Typography>
            <IconButton aria-label="Add to Cart" onClick={handleAddToCart}>
            <AddShoppingCart />
            </IconButton>
        </CardActions>
        </Card>
    );
};

export default Product;

